import React, { useEffect, useState } from "react";
import { ImageBackground, StyleSheet, View, Image, Text, FlatList, Animated } from "react-native";

import Button from "../components/Button";
import routes from "../navigation/routes";

var elementScroll = 0
var timerId
var refFlatList
var elem ='../assets/charliñe.jpg'
function WelcomeScreen({ navigation, route }) {
//debugger
  //Crea una referencia para poder utilizar propiedades de una etiqueta afuera en el area de funciones 
  refFlatList = React.createRef()

  useEffect(() => {
    
    startScroll()
  }, []);
 const [ listing, setListing ] =  useState('') // para que es 
  //Arreglo de imagenes del carrusel
  const items = [
    {
      seedId: 1,
      seedPhoto: "../assets/a.jpg"
    },
    {
      seedId: 2,
      seedPhoto: "../assets/mosh.jpg"
    },
    {
      seedId: 3,
      seedPhoto: "../assets/carlosPerfil.jpg"
    },
    {
      seedId: 4,
      seedPhoto: "../assets/charliñe.jpg"
    }
    
  ]
  //------------------------------------------
  //Empieza un ciclo para recorrer el carrusel
  //------------------------------------------ 
  const startScroll = () => {
    //debugger
    // setInterval es una instrucción de javascript que permite ejecutar una función por inervalos de tiempo 
    timerId = setInterval(slideScroll, 3000)
  }
  //------------------------------------------------------------
  //Desliza los elmentos del carrusel en incrementos uno por uno
  //------------------------------------------------------------
  const slideScroll = () => {
    elementScroll++
    // if (elementScroll < items.length) {
    //   if (refFlatList !== null) {
    //     //Referencia para ocupar elementos del flatList fuera de la etiqueta
    //     refFlatList.current.scrollToIndex({ animated: true, index: elementScroll, viewOffset: 0, viewPosition: 0 })
    //     //console.log('hola')
    //   }
    // } 
    if (elementScroll < items.length) {
     // listing[0].seedPhoto 
     
     setListing(items[elementScroll].seedPhoto)
      elem = items[elementScroll].seedPhoto
      listing
    } 
    else {
      // Devuelve el valor de la posisción del carrusel a la posición inicial
      elementScroll = -1
    }
  }
  //---------------------------
  //Para el avance del carrusel
  //---------------------------
  const stopScroll = () => {
    //clearInterval(timerId) es la instrucción para detener la ejecución de setInterval
    if (timerId) {
      clearInterval(timerId)
    }
  }

  const WIDTH = 500
  //(Dimensions.get('window').height) * .5;
  const sizeItemLayout = (item, index) => (
    { length: WIDTH, offset: WIDTH * index, index }
  );

  return (
    <>
    {
    //.............................................
    //Sección que pinta 
    //.............................................
     elem === '../assets/a.jpg' ? 
     <ImageBackground
      blurRadius={0}
      style={styles.background}
      source={ require('../assets/a.jpg')}
    >
      {/* <FlatList
        //refFlatList={React.createRef()}
        ref={refFlatList}
        data={items}
        keyExtractor={(item) => item.seedId.toString()}
        initialScrollIndex={0}
       // progressViewOffset={5}
        getItemLayout={sizeItemLayout}
        horizontal={true}
        renderItem={({ item, index }) => (
          <ImageBackground
            blurRadius={0}
            style={styles.image}
            source={item.seedPhoto}
          >
          </ImageBackground>
        )}
      /> */}
      <View style={styles.buttonsContainer}>
        <Button
          title="Login"
          onPress={() => {
            stopScroll()
            navigation.navigate(routes.LOGIN)
          }}
        />
        <Button
          title="Crear usuario"
          color="secondary"
          onPress={() => {
            stopScroll()
            navigation.navigate(routes.REGISTER)
          }}
        />
      </View>
    </ImageBackground> 
     :elem === '../assets/mosh.jpg' ? 
     <ImageBackground
      blurRadius={0}
      style={styles.background}
      source={ require('../assets/mosh.jpg')}
    >
      <View style={styles.buttonsContainer}>
        <Button
          title="Login"
          onPress={() => {
            stopScroll()
            navigation.navigate(routes.LOGIN)
          }}
        />
        <Button
          title="Crear usuario"
          color="secondary"
          onPress={() => {
            stopScroll()
            navigation.navigate(routes.REGISTER)
          }}
        />
      </View>
    </ImageBackground> 
    : elem === '../assets/carlosPerfil.jpg' ? 
    <ImageBackground
     blurRadius={0}
     style={styles.background}
     source={ require('../assets/carlosPerfil.jpg')}
   >
    
     <View style={styles.buttonsContainer}>
       <Button
         title="Login"
         onPress={() => {
           stopScroll()
           navigation.navigate(routes.LOGIN)
         }}
       />
       <Button
         title="Crear usuario"
         color="secondary"
         onPress={() => {
           stopScroll()
           navigation.navigate(routes.REGISTER)
         }}
       />
     </View>
   </ImageBackground> 
   : elem === '../assets/charliñe.jpg' ? 
   <ImageBackground
    blurRadius={0}
    style={styles.background}
    source={ require('../assets/charliñe.jpg')}
  >  
    <View style={styles.buttonsContainer}>
      <Button
        title="Login"
        onPress={() => {
          stopScroll()
          navigation.navigate(routes.LOGIN)
        }}
      />
      <Button
        title="Crear usuario"
        color="secondary"
        onPress={() => {
          stopScroll()
          navigation.navigate(routes.REGISTER)
        }}
      />
    </View>
  </ImageBackground> 
  :
     null
    }
    </>
  );
}

const styles = StyleSheet.create({
  background: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  buttonsContainer: {
    padding: 20,
    width: "50%",

  },
  logo: {
    width: 100,
    height: 100,
  },
  logoContainer: {
    position: "absolute",
    top: 70,
    alignItems: "center",
  },
  tagline: {
    fontSize: 25,
    fontWeight: "600",
    paddingVertical: 20,
  },
  image: {
    marginTop: "5%",
    marginBottom: '3%',
    height: '100%',
    width: 500,
  },
});

export default WelcomeScreen;
